import { render, staticRenderFns } from "./StockingUnion.vue?vue&type=template&id=1e498466&scoped=true"
import script from "./StockingUnion.vue?vue&type=script&lang=js"
export * from "./StockingUnion.vue?vue&type=script&lang=js"
import style0 from "./StockingUnion.vue?vue&type=style&index=0&id=1e498466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e498466",
  null
  
)

export default component.exports